import Layout from "../../../layout";
import "./members.css";
import { Link } from "react-router-dom";
import Breadcrumb from "antd/lib/breadcrumb";
import Table from "antd/lib/table";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useDashboard from "../../../hooks/use_dashboard";
import moment from "moment";
import Pagination from "antd/lib/pagination";
import { useSelector } from "react-redux";
import { dateHelper } from "../../../helpers/date_helper";

const Members = () => {
  const { getMembers, membersData, paginates, getMembersLoading } =
    useDashboard();

  const userProfile = useSelector((state) => state.app.userProfile);

  const columns = [
    {
      title: "Member",
      dataIndex: "user.fullname",
      key: "user",
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>{record.user?.fullname}</div>
          <div style={{ color: "var(--black_50)", fontSize: 12 }}>
            {record.user?.email}
          </div>
        </div>
      ),
    },
    {
      title: "Member since",
      dataIndex: "createTime",
      key: "createTime",
      render: (text, record) => dateHelper(record.createTime),
    },
    {
      title: "Course",
      dataIndex: "course.name",
      key: "course",
      render: (text, record) =>
        record.course?.name || <span style={{ color: "#bfbfbf" }}>-</span>,
    },
    {
      title: "Overall progress",
      width: 300,
      dataIndex: "progress",
      key: "progress",
      render: (progress, record) => (
        <div className="progress_bar_table">
          <div className="bar_table">
            <div style={{ width: `${progress > 100 ? 100 : progress}%` }}></div>
          </div>
          <span style={{ color: "#595959" }}>
            {progress > 100 ? 100 : progress}%
          </span>

          {/* <Button
            className="action_btn"
            onClick={() => navigate("/dashboard/members/profile")}
          >
            <MdOutlineRemoveRedEye />
          </Button> */}
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (userProfile) {
      getMembers(1);
    }
  }, [userProfile]);

  return (
    <Layout>
      <div className="members">
        {/* heaer_members */}
        <div className="heaer_members">
          <Breadcrumb
            separator="/"
            className="custom-breadcrumb"
            items={[
              {
                title: (
                  <Link to={"/dashboard"} style={{ color: "var(--second)" }}>
                    Dashboard
                  </Link>
                ),
              },
              {
                title: (
                  <Link
                    to={"dashboard/members"}
                    style={{ color: "var(--text)", fontWeight: "bold" }}
                  >
                    Members
                  </Link>
                ),
              },
            ]}
          />
        </div>
        {/* member_body */}
        <div className="member_body">
          {/* member_title */}
          <div className="member_title">
            <h3>Members</h3>
            <p>Keep track of members and their progress</p>
          </div>
          {/* table_container */}
          <div className="table_container">
            <Table
              loading={getMembersLoading}
              columns={columns}
              dataSource={membersData}
              pagination={false}
              bordered={false}
            />
          </div>
          {membersData.map((data, index) => (
            <div key={index} className="tabel_container_mobile">
              <div>
                <p>Member name</p>
                <span>{data?.user?.fullname}</span>
              </div>
              <div>
                <p>Member since</p>
                <span>{dateHelper(data.createTime)}</span>
              </div>
              <div>
                <p>Course</p>
                <span>{data.course?.name}</span>
              </div>
              <div>
                <div className="bar_table_mobile">
                  <div
                    style={{
                      width: `${data?.progress > 100 ? 100 : data.progress}%`,
                    }}
                  ></div>
                </div>
                <span>{data?.progress > 100 ? 100 : data.progress}%</span>
              </div>
            </div>
          ))}
        </div>
        <Pagination
          style={{ marginTop: 24 }}
          current={paginates.current}
          pageSize={10}
          onChange={(page) => {
            getMembers(page);
          }}
          total={paginates.total * 10}
        />
      </div>
    </Layout>
  );
};

export default Members;
